import React from 'react';
import { Route } from "react-router-dom";
import Navmenu from './NavmenuOther';

const LayoutOther = ({ component: Component, layout: Layout, ...rest }) => {
  if (Layout === undefined) {
    Layout = (props) => <React.Fragment>{props.children}</React.Fragment>;
  }
  return (
    <>
      <Navmenu />
      <Route
        {...rest}
        render={(props) => (
          <Layout {...rest}>
            <Component {...props} />
          </Layout>
        )}
      />
    </>
  );
}

export default LayoutOther;